import { ChangeDetectionStrategy, Component, EventEmitter, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageTitleService, ManagedVendorService } from '@shared/service';
import { computed } from '@angular/core';

/**
 * Vendor topbar (mockup `<header class="topbar">`): mobile brand, page title, the
 * "Customer app" button, the mobile vendor-switch, and the profile avatar.
 */
@Component({
  selector: 'app-header',
  standalone: true,
  styleUrl: './header.component.scss',
  imports: [CommonModule],
  templateUrl: './header.component.html',
  
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  /** Mobile vendor-switch (mockup `#topSwitch`) → opens the switch modal (Phase 4). */
  @Output() switchVendor = new EventEmitter<void>();

  readonly pageTitleSvc = inject(PageTitleService);
  readonly mv = inject(ManagedVendorService);
  private readonly router = inject(Router);

  /** Avatar initials derived from the managed vendor's real name. */
  readonly avatarInitials = computed(() => {
    const parts = (this.mv.name() || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '—';
    const first = parts[0][0] ?? '';
    const last = parts.length > 1 ? (parts[parts.length - 1][0] ?? '') : '';
    return (first + last).toUpperCase();
  });

  goProfile() { void this.router.navigate(['/vendor/profile']); }
}
